import { Check } from "lucide-react";
import { openCalendly } from "@/lib/calendly";

const DELIVERABLES = [
  {
    k: "D-01",
    title: "Bottleneck Scorecard",
    body: "A clear 1-page scorecard rating your business across lead capture, operations, sales follow-up and visibility. No jargon.",
  },
  {
    k: "D-02",
    title: "Top 3 improvement opportunities",
    body: "The three bottlenecks costing you the most right now, with a plain-English explanation of why each one matters.",
  },
  {
    k: "D-03",
    title: "Recommended AI tools & workflow ideas",
    body: "Specific tools, automations and AI workflows matched to your stack and business model — not a generic 'top 10' list.",
  },
  {
    k: "D-04",
    title: "Priority roadmap",
    body: "What to fix first, second and third — ranked on effort vs. business impact so you can act with confidence.",
  },
  {
    k: "D-05",
    title: "Optional implementation plan",
    body: "If you want us to build it, we scope the first fix as a tight, fixed-outcome engagement. No retainer trap.",
  },
];

export default function Deliverables() {
  return (
    <section
      className="bg-white border-b border-zinc-200"
      data-testid="deliverables-section"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-orange-600" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">
                What You Get
              </span>
            </div>
            <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-zinc-950">
              Tangible deliverables. Nothing fluffy.
            </h2>
            <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
              Every assessment ends with documents you can act on — not a slide deck you'll
              never open again.
            </p>

            <a
              href="#book"
              onClick={(e) => {
                e.preventDefault();
                openCalendly();
              }}
              className="mt-8 inline-flex items-center gap-2 bg-zinc-950 text-white px-6 py-3.5 text-sm font-medium border border-zinc-950 hover:-translate-y-0.5 hover:shadow-[4px_4px_0px_0px_rgba(234,88,12,1)] transition-all duration-200"
              data-testid="deliverables-cta"
            >
              Start my assessment →
            </a>
          </div>

          <ul className="lg:col-span-7 divide-y divide-zinc-200 border-y border-zinc-200">
            {DELIVERABLES.map((d, i) => (
              <li
                key={d.k}
                className="grid grid-cols-[auto_1fr_auto] gap-6 py-6 sm:py-7 items-start reveal"
                data-testid={`deliverable-${i}`}
              >
                <span className="font-mono text-xs text-orange-600 pt-1 tabular-nums tracking-[0.18em]">
                  {d.k}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-lg sm:text-xl tracking-tight text-zinc-950">
                    {d.title}
                  </h3>
                  <p className="mt-2 text-zinc-600 leading-relaxed">{d.body}</p>
                </div>
                <Check size={20} className="text-zinc-900 mt-1" aria-hidden="true" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
